<block-ui></block-ui>
  <!-- Page Content -->
  <div class="container-fluid">
    <div *ngIf="ShowPageContent">
      <div class="card card-custom-h">
        <div class="card-header border-0 pt-5">
          <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
            <form [formGroup]="ProviderForm">
              <BBSF-TextBox [options]="searchTextBox" [group]="ProviderForm"></BBSF-TextBox>
            </form>
          </div>
          <div class="card-toolbar">
            <!-- begin::Menu -->
            <div ngbDropdown class="d-inline-block" [ngStyle]="{'display': ShowPageContent==true?'block':'none'}">
              <button (click)="loadLists()" ngbDropdownToggle href="javascript:;" type="button" class="btn btn-sm btn-light-primary me-3" id="FiltersDropdown" title="Filter">
                <i class="fas fa-filter me-1"></i>
                {{utilityService.getResourceValue("Filter")}}
              </button>
              <div *ngIf="IsFilterLoaded" ngbDropdownMenu aria-labelledby="FiltersDropdown" class=" filter-container menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary  w-250px w-md-500px fw-bold py-3 ">
                <form [formGroup]="ProviderForm">
                  <div class="px-7 py-5">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="mb-10">
                          <BBSF-DropdownList #providerTypesDDL [options]="providerTypesFilterOption" [group]="ProviderForm"></BBSF-DropdownList>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="mb-10">
                          <BBSF-DropdownList #sortingFilterDDL [options]="sortingFilterOption" [group]="ProviderForm"></BBSF-DropdownList>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end">
                      <button class="btn btn-light btn-active-light-primary pv-reset btn-sm" d="applyFiltersBtn"
                              (click)="resetFilters()">
                        {{utilityService.getResourceValue("Reset")}}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <button href="javascript:;" (click)="generateProviderJson()" class="btn btn-sm btn-light-primary me-3 bnsights-btn-export">
              <i class="fas fa-file-export me-1"></i>
              {{utilityService.getResourceValue("GenerateProviderJson")}}
            </button>

            <button type="button" title='utilityService.getResourceValue("SelectDefaultProvider")' class="btn btn-sm btn-light-primary me-3 " (click)="showDefaultProviderModal(DefaultProviderModal)">
              <i class="fas fa-hand-pointer me-1"></i>
              {{utilityService.getResourceValue("SelectDefaultProvider")}}
            </button>
            <button type="button" title='utilityService.getResourceValue("Add")' class="btn btn-sm btn-primary" (click)="showAddProviderModal(AddProviderModal)">
              <i class="fas fa-plus me-1"></i>
              {{utilityService.getResourceValue("Add")}}
            </button>        <!-- end::Menu -->
          </div>
        </div>
        <!-- end::Header -->
        <!-- begin::Body -->
        <div class="card-body py-3">
          <div class="table-responsive">
            <!-- begin::Table -->
            <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
              <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                  <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Status")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Default")}}</th>
                  <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
                </tr>
              </thead>
              <tbody id="listingContainer" *ngFor="let providerGroup of ProviderPagingResult" class="fw-bold text-gray-600 border-0">

                <tr *ngFor="let provider of providerGroup.providers">
                  <td>
                    <div class="text-dark">{{provider.providerName}}</div>
                    <div>{{provider.description}}</div>
                  </td>
                  <td>
                    <span class="badge badge-light-primary" *ngIf="provider.isRunning;else other_content">
                      {{utilityService.getResourceValue("Running")}}
                    </span>
                    <ng-template #other_content>
                      <span class="badge badge-light-danger">
                        {{utilityService.getResourceValue("Stopped")}}
                      </span>
                    </ng-template>

                  </td>
                  <td>
                    <span class="badge badge-light-success fw-bolder" *ngIf="provider.isDefault;else default_no">
                      {{utilityService.getResourceValue("Yes")}}
                    </span>
                    <ng-template #default_no>
                      <span class="badge badge-light fw-bolder">
                        {{utilityService.getResourceValue("No")}}
                      </span>
                    </ng-template>
                  </td>
                  <td>
                    <div>
                      <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                        <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                      </button>
                      <mat-menu #menu="matMenu">
                        <a class="drop-item px-3" ngbDropdownItem (click)="showEditProviderModal(provider.id,provider.idEncrypted , EditProviderModal)">
                          <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                        </a>
                        <a ngbDropdownItem class="drop-item px-3" id="btnResetPass"
                           (click)="showDeleteProviderModal(provider, deleteProviderModal)">
                          <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                        </a>
                      </mat-menu>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="providerGroup.providers.length == 0">
                  <td colspan="4">
                    <lib-empty-data></lib-empty-data>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="ProviderPagingResult.length == 0">
                <tr>
                  <td colspan="4">
                    <lib-empty-data></lib-empty-data>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="card-footer border-0">
          <BBSF-Paging (Items)="setProviderListResult($event)" *ngIf="IsFilterLoaded"
                       [options]="ProviderPaging" [group]="ProviderForm" #ProviderPagingViewElement>
          </BBSF-Paging>
        </div>

      </div>

    </div>

    <!--end::Providers list-->
  </div>

  <!-- Add Modal -->
  <ng-template #AddProviderModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">
          {{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("Provider")}}
        </h1>
      </div>
      <BBSF-Form [options]="AddProviderFormOptions">

        <BBSF-TextBox [options]="AddName" [group]="AddProviderForm">
        </BBSF-TextBox>
        <BBSF-TextArea [options]="AddDescription" [group]="AddProviderForm">
        </BBSF-TextArea>
        <BBSF-DropdownList [options]="AddOrganizationOptions" [group]="AddProviderForm">
        </BBSF-DropdownList>
        <BBSF-DropdownList [options]="AddTypeOptions" [group]="AddProviderForm" (OnChange)="setAddProviderAttributes($event)">
        </BBSF-DropdownList>
        <div *ngIf="IsAttributesLoaded">
          <div class="table-responsive">
            <!-- begin::Table -->
            <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer table-w-control">
              <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                  <th class="min-w-150px">{{utilityService.getResourceValue("ProviderAttributeName")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("ProviderAttributeValue")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Encrypted")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Action")}}</th>
                </tr>
              </thead>
              <tbody class="fw-bold text-gray-600 border-0">
                <tr *ngFor="let option of ProviderAttributesOptions;let i=index;">

                  <td>
                    <BBSF-TextBox [options]="option[0]" [group]="AddProviderForm">
                    </BBSF-TextBox>
                  </td>
                  <td>
                    <BBSF-TextBox [options]="option[1]" [group]="AddProviderForm">
                    </BBSF-TextBox>
                  </td>
                  <td>
                    <BBSF-CheckBox [options]="option[2]" [group]="AddProviderForm" (OnChange)="encryptedChange($event,option,true)">
                    </BBSF-CheckBox>
                  </td>

                  <td>
                    <a class="btn btn-icon btn-light-danger btn-sm" (click)="deleteAttribute(option,true)">
                      <i class=" fa fa-trash hidden" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
                <tr *ngIf="ProviderAttributesOptions.length == 0">
                  <td colspan="4">
                    <lib-empty-data></lib-empty-data>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseProviderModal id="CloseAddProviderModal" type="button" class="btn btn-light me-3 btn-sm"
                  data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </BBSF-Form>
    </div>
  </ng-template>


  <!-- Edit model -->
  <ng-template #EditProviderModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">
          {{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("Provider")}}
        </h1>
      </div>
      <BBSF-Form [options]="EditProviderFormOptions">
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditName" [group]="EditProviderForm">
            </BBSF-TextBox>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-TextArea [options]="EditDescription" [group]="EditProviderForm">
            </BBSF-TextArea>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <BBSF-DropdownList [options]="EditTypeOptions" [group]="EditProviderForm" (OnChange)="setEditProviderAttributes($event)">
            </BBSF-DropdownList>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive">
            <!-- begin::Table -->
            <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer table-w-control">
              <thead>
                <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                  <th class="min-w-150px">{{utilityService.getResourceValue("ProviderAttributeName")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("ProviderAttributeValue")}}</th>
                  <th class="min-w-150px">{{utilityService.getResourceValue("Encrypted")}}</th>
                  <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
                </tr>
              </thead>
              <tbody class="fw-bold text-gray-600 border-0">
                <tr *ngFor="let option of EditProviderAttributesOptions;let i=index;">

                  <td>
                    <BBSF-TextBox [options]="option[0]" [group]="EditProviderForm">
                    </BBSF-TextBox>
                  </td>
                  <td>
                    <BBSF-TextBox [options]="option[1]" [group]="EditProviderForm">
                    </BBSF-TextBox>
                  </td>
                  <td>
                    <BBSF-CheckBox [options]="option[2]" [group]="EditProviderForm" (OnChange)="encryptedChange($event,option,true)">
                    </BBSF-CheckBox>
                  </td>

                  <td>
                    <a class="btn btn-icon btn-light-danger btn-sm" (click)="deleteAttribute(option,true)">
                      <i class=" fa fa-trash hidden" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
                <tr *ngIf="EditProviderAttributesOptions.length == 0">
                  <td colspan="4">
                    <lib-empty-data></lib-empty-data>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseEditProviderModal id="CloseEditProviderModal" type="button"
                  data-dismiss="modal" (click)="modal.dismiss()" class="btn btn-light me-3 btn-sm">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </BBSF-Form>
    </div>
  </ng-template>

  <!--delete Modal-->
  <ng-template #deleteProviderModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("Provider")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteProviderModal id="CloseDeleteProviderModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deleteProvider()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>

  <!--Default Provider  Modal-->
  <ng-template #DefaultProviderModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("SelectDefaultProvider")}}</h1>
      </div>
      <BBSF-Form [options]="DefaultProviderFormOptions">
        <div class="row">
          <div class="col-md-12" *ngFor="let defProvider of DefaultProviders;let i=index;">
            <h3 class="text-muted mb-4 fw-boldest">{{defProvider.Name}}</h3>
            <input type="hidden" value="{{defProvider.ID}}" />
            <BBSF-RadioButton [options]="defProvider.ProvidersOption" [group]="DefaultProviderForm"></BBSF-RadioButton>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseDefaultProviderModal id="CloseDefaultProviderModal" type="button"
                  class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>

        </div>
      </BBSF-Form>
    </div>
  </ng-template>


